export const slugifyOptions = {
  replacement: "-",
  lower: true,
  remove: /[^a-zA-Z0-9 -]/g,
};
